import { render, staticRenderFns } from "./receivesList.vue?vue&type=template&id=cdf64b60"
import script from "./receivesList.vue?vue&type=script&lang=js"
export * from "./receivesList.vue?vue&type=script&lang=js"
import style0 from "./receivesList.vue?vue&type=style&index=0&id=cdf64b60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports